import { BOX_SHADOW_8_14_26 } from '@apps/card/constants/boxShadow';
import type { TemplateForAutofill } from '@apps/card/contexts/AutofillContext';
import { useAutofill } from '@apps/card/contexts/AutofillContext';
import { useScaleToContainer } from '@apps/card/hooks/useScaleToContainer';
import { Page } from '@apps/card/routes/CardCustomizer/components/Page';
import { animationTransition } from '@shared/utils/animationTransition';
import { useIsMobileScreen } from '@shared/utils/media/useMediaScreens';
import { Box, Flex } from '@withjoy/joykit';
import { cloneDeep } from 'lodash-es';
import type { ReactNode } from 'react';
import React from 'react';

export const CardThumbnail = (props: { children?: ReactNode; template: TemplateForAutofill }) => {
  const { children, template } = props;
  const isMobile = useIsMobileScreen();

  const [containerRef, decoratorRef, contentRef] = useScaleToContainer<HTMLDivElement>(40);

  const { autofill } = useAutofill();
  const clonedTemplate = cloneDeep(template);
  autofill(clonedTemplate);

  // StationeryTemplate type allows optional themeJSON, but would have been filtered out before arriving here.
  if (!clonedTemplate.themeJSON) return null;

  return (
    <Flex
      ref={containerRef}
      aspectRatio={isMobile ? '8 / 10' : '9 / 10'}
      overflow="hidden" // Needed for Safari
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative" // For badges
      paddingX={isMobile ? 4 : 8}
      paddingY={8}
      background="hsla(45, 12%, 93%, 1)"
      transition={animationTransition('background')}
      _groupHover={{
        background: 'hsla(45, 12%, 73%, 0.4)',
      }}
    >
      <Box
        ref={decoratorRef}
        boxShadow={BOX_SHADOW_8_14_26}
      >
        <Page
          ref={contentRef}
          page={clonedTemplate.themeJSON.card.front}
          width={5}
          height={7}
          rendition="small"
        />
      </Box>
      {children}
    </Flex>
  );
};
